import Phaser from 'phaser'

// 빌드 시 Vite define으로 주입되는 에셋 버전(캐시 무력화용)
declare const __ASSET_VER__: string

export class Boot extends Phaser.Scene {
  constructor() { super('Boot') }

  preload() {
    // 파일명이 동일한 public 에셋의 스테일 캐시를 막기 위해 모든 URL에 버전 쿼리를 붙인다.
    const q = `?v=${__ASSET_VER__}`
    const img = (key: string, p: string) => this.load.image(key, p + q)

    const isPortrait = this.scale.height >= this.scale.width
    const v = isPortrait ? 'portrait' : 'landscape'
    img('bg_lobby', `/assets/bg/bg_lobby_${v}.png`)
    img('bg_game', `/assets/bg/bg_game_${v}.png`)
    img('bg_result', `/assets/bg/bg_result_${v}.png`)
    img('logo', '/assets/sprites/logo.png')
    for (const m of ['main', 'happy', 'sad', 'cheer']) {
      img(`mascot_${m}`, `/assets/sprites/mascot_${m}.png`)
    }
    // Ranking icons (leaderboard): trophy header + medals for ranks 1-3
    img('trophy', '/assets/sprites/icons/icon_trophy.png')
    img('medal_gold', '/assets/sprites/icons/icon_medal_gold.png')
    img('medal_silver', '/assets/sprites/icons/icon_medal_silver.png')
    img('medal_bronze', '/assets/sprites/icons/icon_medal_bronze.png')
    img('crown', '/assets/sprites/icons/icon_crown.png')
    img('rank_badge', '/assets/sprites/icons/icon_rank_badge.png')
    // UI 컨트롤 버튼 아이콘(배경음/효과음 on·off, 일시정지, 나가기)
    img('icon_bgm_on', '/assets/sprites/icons/icon_bgm_on.png')
    img('icon_bgm_off', '/assets/sprites/icons/icon_bgm_off.png')
    img('icon_sfx_on', '/assets/sprites/icons/icon_sfx_on.png')
    img('icon_sfx_off', '/assets/sprites/icons/icon_sfx_off.png')
    img('icon_pause', '/assets/sprites/icons/icon_pause.png')
    img('icon_exit', '/assets/sprites/icons/icon_exit.png')
    // 포인트 코인 + 상점 아이콘/배경 + 상점 아이템 + 로비 버튼(없으면 씬에서 이모지/코드 폴백)
    img('icon_point', '/assets/sprites/icons/icon_point.png')
    img('icon_shop', '/assets/sprites/icons/icon_shop.png')
    img('icon_settings', '/assets/sprites/icons/icon_settings.png')
    img('bg_shop', '/assets/bg/bg_shop_portrait.png')
    for (const k of ['time', 'point2x', 'revive', 'shuffle', 'hammer', 'hint', 'bomb']) img(`item_${k}`, `/assets/sprites/icons/item_${k}.png`)
    for (const b of ['enter', 'practice', 'rank', 'shop', 'back', 'home']) img(`btn_${b}`, `/assets/sprites/icons/btn_${b}.png`)
    img('panel_leaderboard', '/assets/sprites/panel_leaderboard.png')
    // 768x768 spritesheet, 3x3 grid of 256px tiles (no margin/spacing).
    // Frame index 0..8 maps to numbers 1..9 (row-major, left-to-right top-to-bottom).
    this.load.spritesheet('tiles', '/assets/sprites/tiles.png' + q, {
      frameWidth: 256,
      frameHeight: 256,
    })
    const audio = [
      'bgm_lobby', 'bgm_game1', 'bgm_game2', 'bgm_game3', 'bgm_result',
      'block_select', 'block_deselect', 'invalid', 'block_clear', 'combo',
      'time_bonus', 'time_warning', 'countdown', 'stage_clear', 'high_score', 'game_over', 'ui_click',
    ]
    for (const a of audio) this.load.audio(a, `/assets/audio/${a}.mp3${q}`)
  }

  create() {
    // Audio unlock (browser autoplay policy) is handled in scenes that are
    // alive when the user first interacts (Game.create, and Task 11's Lobby
    // start button) — Boot starts Lobby immediately, so an input listener
    // here would be torn down before it ever fires.
    this.scene.start('Lobby')
  }
}
